import React, { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router';
import * as Sentry from '@sentry/react';
import { routes } from './routes';
import { PermissionRoute } from './PermissionRoute';
import { RouteConfig } from '../types/route';
import { LoadingScreen } from '../components/LoadingScreen';
import { RootRedirector } from './RootRedirector';

// Inline SentryRoutes - wrap Routes with Sentry in production
const SentryRoutes = import.meta.env.PROD
  ? Sentry.withSentryReactRouterV7Routing(Routes)
  : Routes;

const NotFoundPage = lazy(() => import('../pages/NotFoundPage'));
const UnauthorizedPage = lazy(() => import('../pages/UnauthorizedPage'));

const renderRoutes = (routes: RouteConfig[]) => {
  return routes.map(route => (
    <Route
      key={route.path}
      path={route.path}
      element={
        route.meta?.permissionCheck ? (
          <PermissionRoute permissionCheck={route.meta.permissionCheck}>
            {route.element}
          </PermissionRoute>
        ) : (
          route.element
        )
      }
    >
      {route.children && renderRoutes(route.children)}
    </Route>
  ));
};

export const AppRoutes: React.FC = () => {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <SentryRoutes>
        <Route path="/" element={<RootRedirector />} />
        {routes.map(route => {
          return (
            <Route key={route.path} path={route.path} element={route.element}>
              {route.children && renderRoutes(route.children)}
            </Route>
          );
        })}
        <Route path="/unauthorized" element={<UnauthorizedPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </SentryRoutes>
    </Suspense>
  );
};
